<template>
    <el-menu class="navbar" mode="horizontal">
        <div class="navbar-right">
            <!-- <img :src="loginImg" class="login-img" /> -->
            <div id="avatarUpload">
                <img :src="loginImg" class="login-img" />
            </div>
            <el-dropdown class="login-img-box" @command="handleCommand">
                <span class="el-dropdown-link login-name" :title="userName">{{userName}}</span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="phone === '13501189583' || phone === '15018955912' || phone === 'Mok' || phone === '65263913' ?false:true" command="message">
                        <div v-if="unreadMsg" class="redSpot" ><i></i></div>
                        <svg aria-hidden="true" class="svg-icon svg-head-icon">
                            <use xlink:href="#icon-tongzhi"></use>
                        </svg>
                        <span>{{ $t('notify.Notifications') }}</span>
                    </el-dropdown-item>

                    <el-dropdown-item command="user">
                        <svg aria-hidden="true" class="svg-icon svg-head-icon">
                            <use xlink:href="#icon-yonghu1"></use>
                        </svg>
                        <span>{{$t('user.title')}}</span>
                    </el-dropdown-item>

                    <el-dropdown-item command="logout">
                        <svg aria-hidden="true" class="svg-icon svg-head-icon">
                            <use xlink:href="#icon-tuichu"></use>
                        </svg>
                        <span>{{$t('index.Logout')}}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>

            </el-dropdown>
            <div class="line-class"></div>
            <div class="lang-box">
                <ul class="lang-ul">
                    <li :class="['lang-item', {'active': isEn}]" @click="changeLocale('en')">En</li>
                    <li :class="['lang-item', {'active': isZh_tw}]" @click="changeLocale('zh_tw')">繁</li>
                    <li :class="['lang-item', {'active': isZh_cn}]" @click="changeLocale('zh_cn')">简</li>
                </ul>
            </div>
            <!-- lang-box结束 -->
        </div>
        <!-- navbar-right结束 -->
        <!-- 展示整个用户信息             -->
        <!--  isShowUser-->
        <el-dialog :title="$t('user.title')" width="360px" :lock-scroll=false :close-on-click-modal=false class="isShowUser notify-dialog" center :show-close=false :visible.sync="dialogUserVisible" custom-class="custom-dialogUser" :modal-append-to-body="true" :append-to-body="true">
            <el-upload id="avatarUpload1" action="/api/share/picture/upload" :on-success="uploadSuccess" :before-upload="beforeImgUpload" :show-file-list="false" name="upfile" list-type="picture" :headers="headers">
                <img :src="loginImg" class="login-img"/>
            </el-upload>
            <div class="user_input">
                <span v-show="isInputVisible" @click="showInput" class="user_text" :title="userName">{{userName}}</span>
                <el-input v-show="!isInputVisible" @clear="clearInput" v-model.trim="userName" @input="setlenght(userName,12)" clearable type="text" :placeholder="$t('user.placeholder')"  autoComplete="off"  id="userName"  @keyup.enter.native="removeStyle"  @blur="removeStyle" ></el-input>
            </div>
            <span class="tip" :title="$t('user.tips')">{{$t('user.tips')}}</span>
            <div class="psw_box">
                <span class="psw-change" @click="showPsw">{{$t('modifyPwd.PasswordChange')}}</span>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitUser()" class="footer-ok">{{$t('user.OK')}}</el-button>
                <el-button @click="closeUser()" class="footer-cancel footer-cancen-btn">{{$t('user.Cancel')}}</el-button>
            </div>
        </el-dialog>
        <!-- 展示整个用户信息 -->
        <!-- 修改密码 -->
        <el-dialog :title="$t('modifyPwd.PasswordChange')" :lock-scroll=false :close-on-click-modal=false class="modifyPwd" :show-close=false :visible.sync="dialogFormVisible" custom-class="custom-dialog" :modal-append-to-body="true" :append-to-body="true">
            <el-form :model="pwdForm" :rules="modifyPwdRule" :inline="true" label-position="top" ref="pwdForm">
                <el-form-item id="oldPwdItem" prop="oldPwd">
                    <div class="controls">
                        <label for="oldPwdInput" id="oldPwd">{{$t('modifyPwd.OriginalPassword')}}</label>
                        <el-input type="password" autoComplete="off" v-model="pwdForm.oldPwd" id="oldPwdInput" class="floatLabel" :maxlength=50 name="Input1" @focus="addActive('oldPwd')" @blur="delActive('oldPwd')" readonly></el-input>
                    </div>
                </el-form-item>
                <el-form-item id="newPwdItem" prop="newPwd">
                    <div class="controls">
                        <label for="newPwdInput" id="newPwd">{{$t('modifyPwd.NewPassword')}}
                            <span class="hintInfo" id="newPwdSpan">{{$t('modifyPwd.PleaseInputMoreThan6DigitsPassword')}}</span>
                        </label>
                        <el-input type="password" autoComplete="off" v-model="pwdForm.newPwd" id="newPwdInput" class="floatLabel" :maxlength=50 name="Input2" @focus="addActive('newPwd','newPwdSpan')" @blur="delActive('newPwd','newPwdSpan')" readonly></el-input>
                    </div>
                </el-form-item>
                <el-form-item id="confirmPwdItem" prop="confirmPwd">
                    <div class="controls">
                        <label for="confirmPwdInput" id="confirmPwd">{{$t('modifyPwd.Confirm')}}
                            <span class="hintInfo" id="comfirmPwdSpan">{{$t('modifyPwd.PleaseBeTheSameAsOriginalPassword')}}</span>
                        </label>
                        <el-input type="password" autoComplete="off" v-model="pwdForm.confirmPwd" id="confirmPwdInput" class="floatLabel" :maxlength=50 name="Input3" @focus="addActive('confirmPwd','comfirmPwdSpan')" @blur="delActive('confirmPwd','comfirmPwdSpan')" readonly></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('pwdForm')" class="footer-ok">{{$t('modifyPwd.OK')}}</el-button>
                <el-button @click="closeModifyPwd('pwdForm')" class="footer-cancel footer-cancen-btn">{{$t('button.Cancel')}}</el-button>
            </div>
        </el-dialog>

        <!-- 消息通知 -->
        <el-dialog v-if="phone === '13501189583' || phone === '15018955912' || phone === 'Mok' || phone === '65263913' ?false:true" :title="$t('notify.NotificationList')" v-loading='notifyLoading' :lock-scroll=false :close-on-click-modal=false class="notify-dialog" :show-close=true :visible.sync="dialogMessage" custom-class="message-dialog" :modal-append-to-body="true" :append-to-body="true">
            <ul class="notify-ul">
                <li class="notify-item" v-for=" (item,index) in notifyData " :key=index @click="showMsgDetail(item,index)">
                    <div>
                        <i v-if="item.readState == 0 "></i>
                        <!-- <span>{{ $t('notify.Notifications') }}</span> -->
                        <span class="nofity-title">{{ item.title }}</span>
                        <span class="nofity-time">{{ item.addedDate | parseTime('{y}-{m}-{d}') }}</span>
                    </div>
                    <div v-html="item.content" style="height:18px"></div>
                </li>
            </ul>
            <el-dialog  :title="$t('notify.NofiticationDetails')" :lock-scroll=false :close-on-click-modal=false class="notify-dialog notify-detail-dialog" :show-close=false :visible.sync="dialogMsgDetail" custom-class="message-dialog" :modal-append-to-body="true" :append-to-body="true">
                <div class="notify-detail">
                    <div>
                        <span> {{ msgDetailData.title }} </span>
                        <span> {{ msgDetailData.addedDate  | parseTime('{y}-{m}-{d}') }} </span>
                    </div>
                    <div v-html="nitifyContent" class="concentBox"></div>
                </div>
                <div slot="footer">
                    <el-button @click="closeMsg" class="footer_ok">{{$t('button.OK')}}</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Levelbar from "./Levelbar";
import TabsView from "./TabsView";
import Hamburger from "components/Hamburger";
import Screenfull from "components/Screenfull";
import ErrorLog from "components/ErrLog";
import errLogStore from "store/errLog";
import { queryIndustry } from "api/merchant/index";
import { modifyPwd,checkPwd,modifyAvatar,modifyUser } from "api/login";
import { findMessageListByUserId, updateMessage } from "api/notify/index";

export default {
    components: { Levelbar, TabsView, Hamburger, ErrorLog, Screenfull },
    data() {
        const checkOldPwd = (rule, value, callback) => {
            if (!value) {
                return callback(
                    new Error(this.$t("modifyPwd.PleaseInputOriginalPassword"))
                );
            } else if (value === "") {
                return callback(
                    new Error(this.$t("modifyPwd.PleaseInputOriginalPassword"))
                );
            } else {
                checkPwd(this.phone, value).then(res => {
                    if (res.code === 0) {
                        callback();
                    } else {
                        return callback(
                            new Error(this.$t("modifyPwd.PasswordIncorrect"))
                        );
                    }
                });
            }
        };
        const checkNewPwd = (rule, value, callback) => {
            if (!value) {
                return callback(
                    new Error(this.$t("modifyPwd.PleaseInputPassword"))
                );
            } else if (value === "") {
                return callback(
                    new Error(this.$t("modifyPwd.PleaseInputPassword"))
                );
            } else if (value === this.pwdForm.oldPwd) {
                return callback(
                    new Error(
                        this.$t("modifyPwd.TheNewPasswordIsTheSameAsTheOldOne")
                    )
                );
            } else if (value.length < 6) {
                return callback(
                    new Error(this.$t("modifyPwd.NewPasswordLessThan6Digits"))
                );
            } else {
                callback();
            }
        };
        const checkConfirmPwd = (rule, value, callback) => {
            if (!value) {
                return callback(
                    new Error(this.$t("modifyPwd.PleaseInputPasswordAgain"))
                );
            }
            if (value === "") {
                return callback(
                    new Error(this.$t("modifyPwd.PleaseInputPasswordAgain"))
                );
            } else if (value !== this.pwdForm.newPwd) {
                return callback(
                    new Error(this.$t("modifyPwd.TheTwoPasswordsDoNotMatch"))
                );
            } else {
                callback();
            }
        };
        return {
            headers: { "access-token": sessionStorage.getItem("access-token") },
            isZh_cn: localStorage.getItem("locale") === "zh_cn" ? true : false,
            isZh_tw: localStorage.getItem("locale") === "zh_tw" ? true : false,
            isEn: localStorage.getItem("locale") === "en" ? true : false,
            log: errLogStore.state.errLog,
            userName: localStorage.getItem("userName"),
            phone: localStorage.getItem("phone"),
            loginImg: localStorage.getItem("userLoginImg")
                ? localStorage.getItem("userLoginImg")
                : "http://unipock.img-cn-shenzhen.aliyuncs.com/201805/20180524110600636.png",
            pwdForm: {
                oldPwd: undefined,
                newPwd: undefined,
                confirmPwd: undefined
            },
            dialogFormVisible: false,
            dialogUserVisible:false,
            isInputVisible:true,
            modifyPwdRule: {
                oldPwd: [{ validator: checkOldPwd, trigger: "blur" }],
                newPwd: [{ validator: checkNewPwd, trigger: "blur" }],
                confirmPwd: [{ validator: checkConfirmPwd, trigger: "blur" }]
            },
            dialogMessage: false,
            notifyData: [],
            dialogMsgDetail: false,
            msgDetailData: {},
            notifyLoading: true,
            unreadMsg:false,
            nitifyContent:'',
        };
    },
    computed: {
        ...mapGetters(["sidebar", "name", "avatar"])
    },
    mounted() {
        $(".navbar-right").removeAttr("tabIndex");
        this.getNotifyList();
    },
    methods: {
        uploadSuccess(res){
            console.log(res,'res-uploadSuccess')
            modifyAvatar({
                userid:localStorage.getItem('access-userId'),
                url:res.value
            }).then(response=>{
                if( response.code == 0 ){
                    this.$notify({
                        title: this.$t("hint.Alert"),
                        message: this.$t("hint.ChangeOK"),
                        type: "success",
                        duration: 3000
                    });
                    this.loginImg = res.value;
                } else {
                    this.$notify({
                        title: this.$t("hint.Alert"),
                        message: this.$t("hint.ChangeFailed"),
                        type: "error",
                        duration: 3000
                    });
                }
            })
        },
        // 限制上传图片大小
        beforeImgUpload(file) {
            const isGIF = file.type === 'image/gif';
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (isGIF) {
                this.$message(this.$t('modifyPwd.formatError'));
                return false;
            }
            if (!isLt5M) {
                this.$message(this.$t("hint.ThePictureSizeMustNotExceed5M"));
                return false;
            }
            return isLt5M ;
        },
        // 對輸入框字符進行限制
         setlenght(str,lenght) {
            let a= 0,b,content,newStr=''
            content = str
            for(let i=0;i<content.length;i++){
                if(content[i].charCodeAt()>0 && content[i].charCodeAt()<255){
                    a+=1
                }else{
                    a+=2
                }
                if(a<=lenght){
                    console.log(length,'jinru')
                    newStr += content[i].charAt()
                }
            }
            b=a>length
            if(b){
                 this.userName = newStr
            }

        },
        removeStyle(){
            console.log('改變時間事件')
            if(this.userName==="" ||!this.userName){
                 this.$message({
                    showClose: true,
                    message: this.$t("user.qualified1"),
                    type: 'warning'
                    });
                this.userName = ""
                this.isInputVisible = false
            }else if(!this.userName.match("^[a-zA-Z0-9_\u4e00-\u9fa5]+$")){
                this.$message({
                    showClose: true,
                    message: this.$t("user.qualified3"),
                    type: 'warning'
                });
                this.userName = ""
                this.isInputVisible = false
            }else{
                this.isInputVisible = true
            }
            
        },
// (\ / : * ? " < > | & !)
        // checkSpecialKey(str) {
        //     var specialKey = "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
        //     for (var i = 0; i < str.length; i++) {
        //         if (specialKey.indexOf(str.substr(i, 1)) != -1) {
        //         return false;
        //         }
        //     }
        // return true;
        // },
        clearInput(){
            this.userName = ""
            this.isInputVisible = false
        },
        showInput(){
            console.log('點擊事件')
            this.isInputVisible = false
        },
        showPsw(){
            this.dialogFormVisible = true;
            this.dialogUserVisible = false;
            if(this.userName===""){
                this.userName = localStorage.getItem("userName")
            }    
        },
        closeMsg() {
            this.dialogMsgDetail = false;
            this.msgDetailData = {};
            for( let i = 0;i<this.notifyData.length;i++){
                if( this.notifyData[i].readState == 0 ){
                    this.unreadMsg = true;
                    break;
                }else{
                    this.unreadMsg = false;
                }
            }
        },
        // 消息详情
        showMsgDetail(item,index) {
            this.msgDetailData = item;
            if( item.msgType == 1 || item.msgType == 2 ) this.nitifyContent = this.msgDetailData.body;
            else this.nitifyContent = this.msgDetailData.body.slice(this.msgDetailData.body.indexOf('</h2>')+5);
            this.dialogMsgDetail = true;
            if( item.readState == 0 ){
                this.updateMsgState(item,index);
            }
        },
        addActive(id, spanId) {
            // 去除input上的readonly属性
            $("#" + id)
                .next()
                .children()
                .removeAttr("readonly");

            $("#" + id).addClass("active");
            if (spanId === null) {
                return false;
            } else {
                $("#" + spanId).addClass("hidden");
            }
        },
        delActive(id, spanId) {
            if (
                this.pwdForm[id] === "" ||
                this.pwdForm[id] === null ||
                this.pwdForm[id] === undefined
            ) {
                $("#" + id).removeClass("active");
            } else {
                return false;
            }
            if (spanId === null) {
                return false;
            } else {
                $("#" + spanId).removeClass("hidden");
            }
        },

        //关闭用戶信息对话框
        closeUser(){
            this.dialogUserVisible = false;
            this.isInputVisible = true
            this.userName = localStorage.getItem("userName")
        },
        //关闭密碼对话框
        closeModifyPwd(formRule) {
            this.dialogFormVisible = false;
            this.dialogUserVisible = true;
            this.isInputVisible = true
            this.$refs[formRule].resetFields();
            this.pwdForm.oldPwd = undefined;
            this.pwdForm.newPwd = undefined;
            this.pwdForm.confirmPwd = undefined;
            $("#oldPwd").removeClass("active");
            $("#newPwd").removeClass("active");
            $("#confirmPwd").removeClass("active");
            $("#newPwdSpan").removeClass("hidden");
            $("#comfirmPwdSpan").removeClass("hidden");
        },
        toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
        },
        changeLocale(value) {
            queryIndustry(
                localStorage.getItem("locale") === "en" ? "1" : "0"
            ).then(res => {
                if (res.code == 0) {
                    localStorage.setItem("locale", value);
                    this.$i18n.locale = value;
                    localStorage.setItem("queryIndustryObj",JSON.stringify(res.value));
                    location.reload();
                }
            });
        },
        showLocale() {
            $(".localeUl").toggleClass("toggle");
            $(".toggleImgBox").toggleClass("toggleImgBox1");
            $(".toggleLi").toggleClass("toggleLi1");
        },
        logout() {
            sessionStorage.removeItem("access-token");
            sessionStorage.removeItem("hideTestData");
            localStorage.clear();
            location.reload();
            //    this.$store.dispatch('LogOut')
            //      .then(() => {
            //        location.reload(); // 为了重新实例化vue-router对象 避免bug
            //      });
        },
        submitForm(form) {
            this.$refs[form].validate(valid => {
                if (valid) {
                    modifyPwd({
                        phone: this.phone,
                        password: this.pwdForm.oldPwd,
                        newPassword: this.pwdForm.newPwd
                    }).then(res => {
                        if (res.code === 0) {
                            this.closeModifyPwd("pwdForm");
                            this.$notify({
                                title: this.$t("hint.Alert"),
                                message: this.$t("hint.OperationSuccess"),
                                type: "success",
                                duration: 2000
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 修改完用戶信息
        submitUser(){
            if(this.userName==="" ||!this.userName){
                   this.$message({
                    showClose: true,
                    message: this.$t("user.qualified2"),
                    type: 'warning'
                    });
                    return false;
            }
            modifyUser({
                        id:localStorage.getItem("access-userId"),
                        userName:this.userName
                    }).then(res => {
                        console.log('res-submitUser: ', res);
                        if (res.code === 0) {
                            localStorage.setItem("userName",this.userName)
                            this.closeUser();
                            this.$notify({
                                title: this.$t("hint.Alert"),
                                message: this.$t("hint.OperationSuccess"),
                                type: "success",
                                duration: 2000
                            });
                        }
                    });
        },
        handleCommand(command) {
            if (command == "user") {
                this.dialogUserVisible = true;
            } else if (command == "logout") {
                this.logout();
            } else {
                this.dialogMessage = true;
            }
        },
        // 查询消息列表
        getNotifyList() {
            const _that = this;
            let obj = {} ;
            obj.companyId = localStorage.getItem("companyId");
            obj.userId = localStorage.getItem("access-userId");

            let msg = {};
            let currency; //货币符号
            if (obj.companyId == "1") currency = "HK$ ";
            if (obj.companyId == "2") currency = "A$ ";
            if (obj.companyId == "3") currency = "MOP$ ";
            const actions = () => {
                return new Map([
                    // remarks 0进件 1修改信息
                    // status 0通过 1驳回
                    // type 0商户 1店铺 2代理商 3公司 4提现审核
                    [
                        /^00[0-4]+/,
                        () => {
                            if( key.substr(2,1) == 0){
                                return msg = {
                                    title: this.$t('notify.Merchant') + this.$t('notify.registrationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Merchant') + this.$t('notify.registrationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 1){
                                return msg = {
                                    title: this.$t('notify.Shop') + this.$t('notify.registrationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Shop') + this.$t('notify.registrationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 2){
                                return msg = {
                                    title: this.$t('notify.Agent') + this.$t('notify.registrationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Agent') + this.$t('notify.registrationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 3){
                                return msg = {
                                    title: this.$t('notify.Company') + this.$t('notify.registrationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Company') + this.$t('notify.registrationYouSubmittedHasBeenApproved'),
                                }
                            }
                        }
                    ],
                    [
                        /^01[0-4]+/,
                        () => {
                            if( key.substr(2,1) == 0){
                                return msg = {
                                    title: this.$t('notify.Merchant') + this.$t('notify.registrationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Merchant') + this.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 1){
                                return msg = {
                                    title: this.$t('notify.Shop') + this.$t('notify.registrationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Shop') + this.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 2){
                                return msg = {
                                    title: this.$t('notify.Agent') + this.$t('notify.registrationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Agent') + this.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 3){
                                return msg = {
                                    title: this.$t('notify.Company') + this.$t('notify.registrationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Company') + this.$t('notify.registrationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                        }
                    ],
                    [
                        /^10[0-4]+/,
                        () => {
                            if( key.substr(2,1) == 0){
                                return msg = {
                                    title: this.$t('notify.Merchant') + this.$t('notify.informationModificationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Merchant') + this.$t('notify.informationModificationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 1){
                                return msg = {
                                    title: this.$t('notify.Shop') + this.$t('notify.informationModificationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Shop') + this.$t('notify.informationModificationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 2){
                                return msg = {
                                    title: this.$t('notify.Agent') + this.$t('notify.informationModificationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Agent') + this.$t('notify.informationModificationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 3){
                                return msg = {
                                    title: this.$t('notify.Company') + this.$t('notify.informationModificationApproved'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Company') + this.$t('notify.informationModificationYouSubmittedHasBeenApproved'),
                                }
                            }
                            if( key.substr(2,1) == 4 ){
                                if( localStorage.getItem('locale') == 'en' ){
                                    return msg = {
                                        title: this.$t('notify.withdrawalApplicationApproved'),
                                        body: this.$t('notify.theWithdrawalApplicationOf') + currency + money + this.$t('notify.on') + time + this.$t('notify.youSubmittedHasBeenApproved'),
                                    }
                                }
                                if( localStorage.getItem('locale') != 'en' ){
                                    return msg = {
                                        title: this.$t('notify.withdrawalApplicationApproved'),
                                        body: this.$t('notify.theWithdrawalApplicationOf') + time + this.$t('notify.on')  + currency + money + this.$t('notify.youSubmittedHasBeenApproved'),
                                    }
                                }
                                
                            }
                        }
                    ],
                    [
                        /^11[0-4]+/,
                        () => {
                            if( key.substr(2,1) == 0){
                                return msg = {
                                    title: this.$t('notify.Merchant') + this.$t('notify.informationModificationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Merchant') + this.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 1){
                                return msg = {
                                    title: this.$t('notify.Shop') + this.$t('notify.informationModificationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Shop') + this.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 2){
                                return msg = {
                                    title: this.$t('notify.Agent') + this.$t('notify.informationModificationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Agent') + this.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 3){
                                return msg = {
                                    title: this.$t('notify.Company') + this.$t('notify.informationModificationRejected'),
                                    body: this.$t('notify.the') + "“" + name + "”" + this.$t('notify.Company') + this.$t('notify.informationModificationYouSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                }
                            }
                            if( key.substr(2,1) == 4 ){
                                if( localStorage.getItem('locale') == 'en' ){
                                    return msg = {
                                        title: this.$t('notify.withdrawalApplicationRejected'),
                                        body: this.$t('notify.theWithdrawalApplicationOf') + currency + money + this.$t('notify.on') + time + this.$t('notify.youSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                    }
                                }
                                if( localStorage.getItem('locale') != 'en' ){
                                    return msg = {
                                        title: this.$t('notify.withdrawalApplicationRejected'),
                                        body: this.$t('notify.theWithdrawalApplicationOf') + time + this.$t('notify.on')  + currency + money + this.$t('notify.youSubmittedHasBeenRejectedRejectReason') + rejectReasons,
                                    }
                                }
                            }
                        }
                    ],
                ]);
            }; 
            let info,name,rejectReasons; //info=当系统自动发审核类消息时，返回这条数据中的title包含了标题跟内容，body为名称。 name=被驳回的商户,店铺,代理商,公司的名称。 rejectReasons=驳回原因
            let key; //包含了remarks status type 按顺序排列
            let action;
            let time,money; //兑现审核的时间 金额
            findMessageListByUserId(obj).then(res => {
                if( res.code == 0 ){
                    this.notifyData = res.value.rows;
                    
                    for( let i = 0;i < _that.notifyData.length;i++){                   
                        if( _that.notifyData[i].msgType != 0 ){
                            info = JSON.parse(_that.notifyData[i].title);
                            rejectReasons  = _that.notifyData[i].content;
                            if( _that.notifyData[i].msgType == 1 ){
                                // 审核消息
                                name = _that.notifyData[i].body;
                                key = info.remarks + info.status + info.type;    
                            } else if( _that.notifyData[i].msgType == 2 ){
                                // 提现消息
                                time = JSON.parse(_that.notifyData[i].body).time;
                                money = _that.fmoney(JSON.parse(_that.notifyData[i].body).money);
                                key = '1' + info.status + info.type;    
                            }
                            
                            action = [...actions()].filter(([item, value]) => item.test(key) );
                            action.forEach(([item, value]) => value.call(this));
                            _that.notifyData[i].title = msg.title;
                            _that.notifyData[i].body = msg.body;
                            _that.notifyData[i].content = msg.body;
                        }
                    }
                    for( let i = 0;i < _that.notifyData.length;i++){                   
                        if( _that.notifyData[i].readState == 0 ){
                            // 是否有未读消息
                            _that.unreadMsg = true;
                            break;
                        }
                    }
                }
            });
        },
        // 更新消息状态
        updateMsgState(item,index){
            let obj = {
                id : item.id,
                readState : 1
            };
            updateMessage(obj).then(res=>{
                if( res.code == 0 ){
                    this.notifyData[index].readState = 1;
                }
            });
        },
        // 格式化金额
        fmoney(s) {
            if (s === "" || s === undefined) return (s = "0.00");
            s = s / 100;
            let n = 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            var l = s
                    .split(".")[0]
                    .split("")
                    .reverse(),
                r = s.split(".")[1];
            let t = "";
            for (let i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
            }
            t = t.split("").reverse().join("") + "." + r;
            if (t.includes("-")) {
                let n = t.indexOf("-") + 1;
                if (t[n] == ",") {
                    t = "-" + t.substring(n+1);
                }
            }
            return t;
        },
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
    height: 78px;
    background-color: #f6f6f6;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    border-bottom: 0;
    min-width: 1000px;
    .navbar-right {
        height: 78px;
        float: right;
        margin-right: 37px;
        overflow: hidden;
        cursor: pointer;
        .login-img-box {
            float: left;
            // margin-right:10px;
        }
        .login-img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: block;
            margin: 9px 0;
            float: left;
        }
        .login-name {
            display: block;
            float: left;
            font-size: 18px;
            padding: 28px 10px 28px 18px;
            position: relative;
            color: #333;
            max-width: 150px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            outline: none;
            &:after {
                content: " ";
                width: 4px;
                height: 4px;
                border-color: #333 transparent;
                border-width: 0 0 9px 9px;
                border-style: solid;
                position: absolute;
                right: 0px;
                bottom: 17px;
            }
            //   &:hover {
            //     &:after {
            //       transform:rotate(45deg);
            //     }
            //   }
        }
        .line-class {
            width: 1px;
            height: 46px;
            background-color: #999;
            float: left;
            margin: 16px 15px 16px 10px;
        }
        .lang-box {
            overflow: hidden;
            float: left;
            padding: 23px 0;
            .lang-ul {
                list-style-type: none;
                overflow: hidden;
                padding: 0;
                .lang-item {
                    float: left;
                    width: 32px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 18px;
                    color: #888;
                }
                .lang-item + .lang-item {
                    margin-left: 6px;
                }
                .active {
                    background: rgba(82, 114, 233, 1);
                    color: #fff;
                }
            }
        }
    }
}

.modifyPwd .el-dialog__footer .dialog-footer .footer-cancel {
    margin: 0;
}
.isShowUser .el-dialog__footer .dialog-footer .footer-cancel {
    margin: 0;
}

.modifyPwd .el-dialog__footer .dialog-footer .footer-cancel:hover {
    background-color: #fff !important;
}
.isShowUser .el-dialog__footer .dialog-footer .footer-cancel:hover {
    background-color: #fff !important;
}
.controls {
    text-align: left;
    position: relative;
}
.controls input[type="text"],
.controls input[type="email"],
.controls input[type="tel"],
.controls textarea,
.controls button,
.controls select {
    padding: 12px;
    font-size: 14px;
    border: 1px solid #c6c6c6;
    width: 100%;
    margin-bottom: 18px;
    color: #888;
    font-family: "Lato", "sans-serif";
    font-size: 16px;
    font-weight: 300;
    background-color: #fff;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}
.controls input[type="text"]:focus,
.controls input[type="text"]:hover,
.controls input[type="email"]:focus,
.controls input[type="email"]:hover,
.controls input[type="tel"]:focus,
.controls input[type="tel"]:hover,
.controls textarea:focus,
.controls textarea:hover,
.controls button:focus,
.controls button:hover,
.controls select:focus,
.controls select:hover {
    outline: none;
    border-color: #9fb1c1;
}
.controls input[type="text"]:focus + label,
.controls input[type="text"]:hover + label,
.controls input[type="email"]:focus + label,
.controls input[type="email"]:hover + label,
.controls input[type="tel"]:focus + label,
.controls input[type="tel"]:hover + label,
.controls textarea:focus + label,
.controls textarea:hover + label,
.controls button:focus + label,
.controls button:hover + label,
.controls select:focus + label,
.controls select:hover + label {
    color: #077abc;
    cursor: text;
}
.controls label {
    position: absolute;
    top: -6px;
    left: 0;
    color: #666666;
    font-size: 18px;
    display: inline-block;
    z-index: 99;
    font-weight: bold;
    background-color: rgba(255, 255, 255, 0);
    pointer-events: none;
    transition: color 0.3s, top 0.3s, background-color 0.8s;
}
.controls label.active {
    top: -25px;
    color: #333333;
    background-color: white;
    font-size: 14px;
}
.hintInfo {
    font-size: 12px;
    font-weight: normal;
    color: #999999;
}
.controls span.hidden {
    display: none;
}

@media only screen and (max-width: 1200px) {
    .navbar .logo {
        width: 50%;
    }
}

.redSpot {
    position: relative;
    i{
        position: absolute;
        width: 7px;
        height: 7px;
        background-color: red;
        top: 8px;
        left: 12px;
        border-radius: 50%;
    }
}

#avatarUpload{
    float: left;
}
.isShowUser{
    width: 100%;
#avatarUpload1{
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: center;
   .el-upload{
        width: 120px;
        height: 120px;  
        .login-img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            display: block;
        }
    }
}
.user_input{
    width: 100%;
    margin: 10px auto;
    text-align: center;
    display: flex;
    justify-content: center;
    .el-input{
        width: 60%;
        font-size: 16px;
    }
    .user_text{
        font-size: 24px;
        font-weight: bold;
        text-align: center;
    }
}
.tip{
    display: inline-block;
    width: 100%;
    height: 10%;
    text-align: center;
    color: #d7d7d7;
}
.psw_box{
    width: 100%;
    height: 20px;
    display: flex;
    justify-content: center;
    margin: 15px 0;
    text-align: center;
    &:hover{
        cursor: pointer;
    }
.psw-change{
    display: inline-block;
    height: 20px;
    line-height: 20px;
    font-size: 18px;
    text-align: center;
    text-decoration: underline;
    color: #5272e9;
}
}

.el-dialog__footer{  
    height: 0 !important;
    background: #fff;
    .dialog-footer{
        background: #fff;
        .footer-ok{
        margin-top: -100px;
        margin-bottom: 10px;
        }
        .footer-cancel{
        }
    }
  
}
}

</style>



// WEBPACK FOOTER //
// Navbar.vue?2e82faee